import React from 'react';

import { QueryStatus } from '@lumapps/base-api/react-query';
import { useGetProviderList } from '@lumapps/connectors/hooks/useGetProviderList';
import type { Provider } from '@lumapps/connectors/types';

export interface UseProviderList {
    /** Status of the get of the provider list */
    status: QueryStatus;
    /** Get the provider corresponding to the given provider type */
    getProvider: (providerType: string) => Provider | undefined;
}

export const useProviderList = (): UseProviderList => {
    const { items: providerList, status } = useGetProviderList({});

    /**
     * Retrieves a provider from the given state based on its type.
     *
     * @param {string} providerType
     * @returns {Provider | undefined}
     */
    const getProvider = React.useCallback(
        (providerType: string) => providerList?.find((provider) => provider.type === providerType),
        [providerList],
    );

    return { status, getProvider };
};
